// extracted by mini-css-extract-plugin
export default {"radio":"MGInputRadioButton_radio__Wfa84","input":"MGInputRadioButton_input__x+2Dp","visual":"MGInputRadioButton_visual__FR7QV","inner":"MGInputRadioButton_inner__B9oeT"};